import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SearchUtilityBarDropdownItem} from "../search-utility-bar-dropdown-item";

@Component({
  selector: 'app-search-utility-bar-dropdown',
  templateUrl: './search-utility-bar-dropdown.component.html',
  styleUrls: ['./search-utility-bar-dropdown.component.scss']
})
export class SearchUtilityBarDropdownComponent {

  @Input()
  items!: SearchUtilityBarDropdownItem[];

  @Input()
  defaultText!: string;

  @Input()
  extraClass: string | undefined;

  @Output()
  choose: EventEmitter<number | string> = new EventEmitter<number | string>();

  isOpen: boolean = false;
  isActive: boolean = false;

  toggle(): void {
    this.isOpen = !this.isOpen;
  }

  close(): void {
    this.isOpen = false;
  }

  onClickItem(value: number | string): void {
    this.close();
    this.choose.emit(value);
  }

  getSelectedItem(): SearchUtilityBarDropdownItem | undefined {
    if (!this.items) {
      return undefined;
    }

    return this.items.find(item => item.isSelected);
  }

  getText(): string {
    const activeItem: SearchUtilityBarDropdownItem | undefined = this.getSelectedItem();

    if (activeItem !== undefined) {
      return activeItem.displayText;
    }

    return this.defaultText;
  }
}
